var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"Seleccionar"},on:{"change":_vm.onSelectTax},model:{value:(_vm.taxesId),callback:function ($$v) {_vm.taxesId=$$v},expression:"taxesId"}},_vm._l((_vm.taxes),function({ id, title },index){return _c('el-option',{key:index,attrs:{"label":title,"value":id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }